import React from 'react';
import { translate } from 'react-i18next';

import * as Catalog from 'catalogs/components/form';
import * as Common from 'common/components';

const CatalogFormView = ({
  t,
  catalog,
  company,
  handleAddElement,
  handleRemoveElement,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  isSubmitted,
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    <Common.Header title={t('catalogs.catalogs_title')} />
    <div className="col-12">
      <Common.Portlet title={t(catalog.id ? 'catalogs.edit' : 'catalogs.add')} icon={'list-ul'}>
        <Catalog.Form
          company={company}
          handleAddElement={handleAddElement}
          handleRemoveElement={handleRemoveElement}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSaving={isSaving}
          isSubmitted={isSubmitted}
          subcompany={subcompany}
          values={catalog}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(CatalogFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/CatalogFormView.js